<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconExpand_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11.538 4.251 7.253 8.537a.856.856 0 1 0 1.211 1.212l3.68-3.68 3.68 3.68a.856.856 0 1 0 1.211-1.212L12.75 4.25a.856.856 0 0 0-1.212 0m1.211 15.498 4.286-4.286a.856.856 0 1 0-1.212-1.212l-3.68 3.68-3.68-3.68a.856.856 0 1 0-1.212 1.212l4.286 4.286a.856.856 0 0 0 1.212 0"
        clip-rule="evenodd"
    />
</svg>
